import Icon from '../../../components/AppIcon';

const QuickActions = ({ actions, onActionClick }) => {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="Zap" size={20} className="text-primary" />
          <h3 className="font-semibold text-foreground">Quick Actions</h3>
        </div>
      </div>
      <div className="p-4 grid grid-cols-1 gap-2">
        {actions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => onActionClick(action)}
            className="flex items-center gap-3 p-3 rounded-lg hover:bg-muted/50 transition-colors text-left group"
          >
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${action?.bgColor} ${action?.color}`}>
              <Icon name={action?.icon} size={20} />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground group-hover:text-primary transition-colors">
                {action?.label}
              </p>
              {action?.description && (
                <p className="text-xs text-muted-foreground">{action?.description}</p>
              )}
            </div>
            <Icon name="ChevronRight" size={16} className="text-muted-foreground group-hover:text-primary transition-colors" />
          </button>
        ))}
      </div>
      <div className="p-4 border-t border-border bg-muted/30">
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>Keyboard shortcuts enabled</span>
          <span className="flex items-center gap-1">
            <kbd className="px-2 py-1 bg-card border border-border rounded text-xs">1-9</kbd>
            <span>to jump</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;